import React from "react";
import { useLocation, Link, useParams } from "react-router-dom";

function ProductNavbar() {
  const location = useLocation();
  const { uuid } = useParams(); // get uuid from URL

  const tabs = [
    { name: "Basic Details", path: "edit-product" },
    { name: "Product Gallery", path: "gallery" },
    { name: "Product Variant", path: "variant" },
    { name: "Product Attribute", path: "attribute" },
    // { name: "Delivery Setting", path: "delivery" },
  ];

  return (
    <nav style={{ borderBottom: "1px solid #ccc", marginBottom: "20px" }}>
      <ul style={{ display: "flex", listStyle: "none", padding: 0, margin: 0 }}>
        {tabs.map((tab) => {
          const fullPath = `/${tab.path}/${uuid}`;
          const isActive = location.pathname === fullPath;

          return (
            <li
              key={tab.path}
              style={{
                marginRight: "20px",
                padding: "10px 0",
                borderBottom: isActive ? "2px solid blue" : "none",
                fontWeight: isActive ? "600" : "400",
              }}
            >
              <Link
                to={fullPath}
                style={{
                  textDecoration: "none",
                  color: isActive ? "blue" : "#333",
                }}
              >
                {tab.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default ProductNavbar;
